import React from 'react';
import { useTranslation } from 'react-i18next';

const ICONS = {
  planejamento: '\u{1F4A1}', // 💡
  producao: '\u{1F3AC}', // 🎬
  finalizado: '\u{2728}', // ✨
  postado: '\u{1F680}', // 🚀
};

const KanbanEmptyColumn = ({ column }) => {
  const { t } = useTranslation();
  const icon = ICONS[column.id] || ICONS.planejamento;

  const MESSAGES = {
    planejamento: {
      title: t('kanban.empty_planning'),
      subtitle: t('kanban.empty_planning_desc'),
    },
    producao: {
      title: t('kanban.empty_production'),
      subtitle: t('kanban.empty_production_desc'),
    },
    finalizado: {
      title: t('kanban.empty_finished'),
      subtitle: t('kanban.empty_finished_desc'),
    },
    postado: {
      title: t('kanban.empty_published'),
      subtitle: t('kanban.empty_published_desc'),
    },
  };

  const msg = MESSAGES[column.id] || MESSAGES.planejamento;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px 16px',
        textAlign: 'center',
      }}
    >
      <span style={{ fontSize: '32px', marginBottom: '12px', opacity: 0.5 }}>
        {icon}
      </span>
      <p
        style={{
          fontSize: '13px',
          fontWeight: 500,
          color: 'var(--dp-text-secondary, #9CA3AF)',
          margin: '0 0 4px 0',
          fontFamily: 'var(--dp-font)',
        }}
      >
        {msg.title}
      </p>
      <p
        style={{
          fontSize: '11px',
          color: 'var(--dp-text-tertiary, #6B7280)',
          margin: 0,
          fontFamily: 'var(--dp-font)',
        }}
      >
        {msg.subtitle}
      </p>
    </div>
  );
};

export default KanbanEmptyColumn;
